import React from "react";
import logo from "../assets/images/homePage/Footerlogo.svg";
import useTranslation from "../Languages/Translation";

function Footer() {

  const translation = useTranslation();

  return (
    <div className=" main_container">
      <div className=" grid  grid-cols-12 pb-[80px] md:pb-[160px] pt-[80px]">
        <div className=" lg:col-span-7 col-span-12">
          <img src={logo} alt="logo" className=" cursor-pointer"></img>
          <p className="text-[14px] text-white pt-[24px] aeonik_normal">
            © 2023 Piku. All rights reserved.
          </p>
        </div>
        <div className="lg:col-span-5 col-span-12">
          <div className="flex flex-wrap items-end justify-between">
            <ul className="pr-[20px] xl:pr-[40px] pt-[20px] lg:pt-0">
              <li className="text-[18px] aeonik_medium text-white pb-[16px]">{translation.Resources}</li>
              <li className="text-[14px] text-white cursor-pointer aeonik_normal">{translation.Whitepaper}</li>
              <li className="text-[14px] text-white cursor-pointer aeonik_normal my-[16px]">{translation.Audits}</li>
              <li className="text-[14px] text-white cursor-pointer aeonik_normal">{translation.Events}</li>
            </ul>
            <ul className="px-[20px] xl:px-[40px]">
              <li className="text-[14px] text-white cursor-pointer aeonik_normal">{translation.Contracts}</li>
              <li className="text-[14px] text-white cursor-pointer aeonik_normal my-[16px]">{translation.BugBounty}</li>
              <li className="text-[14px] text-white cursor-pointer aeonik_normal">{translation.FAQ}</li>
            </ul>
            <ul className="pt-[20px] md:pt-0 pl-[20px] xl:pl-[40px]">
              <li className="text-[14px] text-white cursor-pointer aeonik_normal">{translation.DeveloperDocs}</li>
              <li className="text-[14px] text-white cursor-pointer aeonik_normal my-[16px]">{translation.News}</li>
              <li className="text-[14px] text-white cursor-pointer aeonik_normal">{translation.Github}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
